export default {
  name: 'affiliates',

  translatedAttributes: [
  ],

  /**
   * Prepare item data for backend request
   * @param item
   * @returns Object
   */
  toArray: item => ({
    ...item,
    commission: item.commission_type === 'fixed' ? item.commission * 100 : item.commission,
  }),

  /**
   * Parse backend payload to item object
   * @param data
   * @param initialItemData
   * @returns Object
   */
  fromArray: (data, initialItemData = {}) => ({
    ...initialItemData,
    ...data,
    commission: data.commission_type === 'fixed' ? data.commission / 100 : data.commission,
  }),

  resolveValidationErrors: errors => ({
    ...errors,
  }),
}
